export default {
  editorMdLoaded: false
}
